export default {
  editorMdLoaded: false
}
